import { usePageSEO } from '@/hooks/usePageSEO';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import PourquoiInspecter from './components/PourquoiInspecter';
import CeQuOnInspecte from './components/CeQuOnInspecte';
import ProcessInspection from './components/ProcessInspection';
import QuandInspecter from './components/QuandInspecter';
import RapportExemple from './components/RapportExemple';
import Temoignage from './components/Temoignage';
import FAQ from './components/FAQ';
import QuoteForm from './components/QuoteForm';
import CTAFinal from './components/CTAFinal';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Accueil', item: 'https://couvreur-levis.com/' },
    { '@type': 'ListItem', position: 2, name: 'Inspection toiture', item: 'https://couvreur-levis.com/inspection-toiture' },
  ],
};

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Inspection de toiture',
  provider: { '@type': 'LocalBusiness', '@id': 'https://couvreur-levis.com/#business' },
  areaServed: { '@type': 'City', name: 'Lévis' },
  description: "Inspection de toiture à Lévis. Rapport photo complet sous 48h, recommandations chiffrées et prioritaires.",
  offers: {
    '@type': 'AggregateOffer',
    priceCurrency: 'CAD',
    lowPrice: '250',
    highPrice: '500',
    offerCount: '1',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: "Pourquoi l'inspection est-elle gratuite ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "L'inspection est gratuite parce qu'on croit que chaque propriétaire mérite de connaître l'état de sa toiture sans barrière financière. C'est aussi notre façon de vous faire découvrir notre travail de qualité. Si une réparation s'avère nécessaire, vous aurez déjà confiance en nous. Si tout va bien, vous aurez la tranquillité d'esprit. C'est gagnant-gagnant.",
      },
    },
    {
      '@type': 'Question',
      name: "Êtes-vous obligé de me vendre une réparation ensuite ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Absolument pas. L'inspection est sans engagement total. On vous présente les faits, le rapport est à vous. Si vous voulez qu'on fasse les travaux, tant mieux. Si vous préférez attendre ou faire ailleurs, c'est votre choix. On ne fait pas de pression — c'est notre promesse.",
      },
    },
    {
      '@type': 'Question',
      name: "Combien de temps prend une inspection ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "L'inspection sur place dure entre 45 et 60 minutes selon la taille et la complexité de votre toiture. On inspecte l'extérieur (bardeaux, solins, gouttières, ventilation) et, si possible, l'intérieur du entretoit pour détecter les infiltrations. Le rapport détaillé vous est envoyé par courriel sous 48h après la visite.",
      },
    },
    {
      '@type': 'Question',
      name: 'Le rapport est-il accepté par les assureurs ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Oui, notre rapport est rédigé au format professionnel reconnu par la plupart des assureurs québécois. Il inclut des photos annotées, une évaluation de l'état de chaque composante, et des recommandations priorisées. Plusieurs clients l'ont utilisé pour satisfaire les demandes de leur assureur. Si besoin, on peut aussi fournir un document complémentaire sur demande.",
      },
    },
    {
      '@type': 'Question',
      name: "Faut-il être présent pendant l'inspection ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "C'est préférable mais pas obligatoire. Si vous êtes là, on peut vous expliquer en direct ce qu'on observe et répondre à vos questions. Si vous n'êtes pas disponible, on inspecte quand même et on vous envoie le rapport par courriel. On peut aussi faire un suivi téléphonique pour discuter des résultats.",
      },
    },
  ],
};

export default function InspectionPage() {
  usePageSEO({
    title: 'Inspection toiture Lévis | Rapport photo détaillé',
    description: 'Inspection de toiture à Lévis. Rapport photo complet sous 48h, recommandations chiffrées. Soumission gratuite. 418-476-9950.',
    urlPath: '/inspection-toiture',
    keywords: 'inspection toiture Lévis, rapport toiture, expertise toiture, état toiture, couvreur',
    ogImage: '/og/og-inspection-toiture.jpg',
    ogImageAlt: 'Inspection de toiture à Lévis - Rapport photo détaillé sous 48h',
    jsonLdSchema: [breadcrumbSchema, serviceSchema, faqSchema],
  });

  return (
    <div className="font-inter min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <PourquoiInspecter />
        <CeQuOnInspecte />
        <ProcessInspection />
        <QuandInspecter />
        <RapportExemple />
        <Temoignage />
        <FAQ />
        <QuoteForm />
        <CTAFinal />
      </main>
      <Footer />
    </div>
  );
}